"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _reactI18next = require("react-i18next");
var _allergens = require("../../services/allergens");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  item: {
    alignItems: "center",
    background: theme.palette.background.light,
    color: theme.palette.text.primary,
    display: "flex",
    height: 50,
    padding: theme.spacing(0, 2)
  },
  letter: {
    alignItems: "center",
    background: theme.palette.background.allergenIcon,
    borderRadius: "50%",
    color: theme.palette.common.white,
    display: "flex",
    fontSize: 14,
    fontWeight: 700,
    height: 24,
    justifyContent: "center",
    marginRight: theme.spacing(2),
    width: 24
  },
  title: {
    fontWeight: 600
  }
}));
const Allergens = () => {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: css.root,
    my: 6
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, _allergens.allergens.map(_ref => {
    let {
      id,
      title,
      value
    } = _ref;
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      md: 4,
      key: id
    }, /*#__PURE__*/_react.default.createElement(_core.Box, {
      className: css.item
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: css.letter
    }, value), /*#__PURE__*/_react.default.createElement("p", {
      className: css.title
    }, t(title))));
  })));
};
var _default = exports.default = Allergens;